import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { ActivityLogSchema } from './activity-log.schema';

export const activityLogContract = createRESTContract({
  getActivityLogs: {
    method: 'GET',
    path: '/logs',
    permissions: [PERMISSIONS.LOGS.VIEW_LOGS],
    response: z.array(ActivityLogSchema),
    query: z.object({
      filter: z.string().optional(),
    }),
  },
});
